import * as types from '../../types/dashboard/dashboardTypes';
import dayjs from 'dayjs';

const initialState = {
  loading: false,
  error: null,
  recentIssues: [],
  recentReturns: [],
  departmentWisePending: [],
  departmentWiseProduction: [],
  batchSummary: {
    total_batches: 0,
    processed_batches: 0,
    pending_batches: 0,
    total_gross_weight: 0,
    total_net_weight: 0,
    loading: false,
    error: null,
  },
  pendingSummary: {
    total_items: 0,
    processed_batches: 0,
    pending_batches: 0,
    total_weight: 0,
    loading: false,
    error: null,
  },
  filters: {
    // Default: today
    dateFrom: dayjs().format('YYYY-MM-DD'),
    dateTo: dayjs().format('YYYY-MM-DD')
  }
};

const dashboardReducer = (state = initialState, action) => {
  switch (action.type) {
    // Dashboard Data
    case types.GET_DASHBOARD_DATA_REQUEST:
      return { ...state, loading: true, error: null };
    case types.GET_DASHBOARD_DATA_SUCCESS:
      return {
        ...state,
        loading: false,
        recentIssues: action.payload.recentIssues || [],
        recentReturns: action.payload.recentReturns || [],
        departmentWisePending: action.payload.departmentWisePending || [],
        departmentWiseProduction: action.payload.departmentWiseProduction || [],
        batchSummary: action.payload.batchSummary || state.batchSummary,
        pendingSummary: action.payload.pendingSummary || state.pendingSummary,
        error: null
      };
    case types.GET_DASHBOARD_DATA_FAILURE:
      return { ...state, loading: false, error: action.payload };

    // Recent Stock Issues
    case types.GET_RECENT_STOCK_ISSUES_REQUEST:
      return { ...state, loading: true, error: null };
    case types.GET_RECENT_STOCK_ISSUES_SUCCESS:
      return { ...state, loading: false, recentIssues: action.payload, error: null };
    case types.GET_RECENT_STOCK_ISSUES_FAILURE:
      return { ...state, loading: false, error: action.payload };

    // Recent Stock Returns
    case types.GET_RECENT_STOCK_RETURNS_REQUEST:
      return { ...state, loading: true, error: null };
    case types.GET_RECENT_STOCK_RETURNS_SUCCESS:
      return { ...state, loading: false, recentReturns: action.payload, error: null };
    case types.GET_RECENT_STOCK_RETURNS_FAILURE:
      return { ...state, loading: false, error: action.payload };

    // Department Wise Pending
    case types.GET_DEPARTMENT_WISE_PENDING_REQUEST:
      return { ...state, loading: true, error: null };
    case types.GET_DEPARTMENT_WISE_PENDING_SUCCESS:
      return { ...state, loading: false, departmentWisePending: action.payload, error: null };
    case types.GET_DEPARTMENT_WISE_PENDING_FAILURE:
      return { ...state, loading: false, error: action.payload };

    // Department Wise Production
    case types.GET_DEPARTMENT_WISE_PRODUCTION_REQUEST:
      return { ...state, loading: true, error: null };
    case types.GET_DEPARTMENT_WISE_PRODUCTION_SUCCESS:
      return { ...state, loading: false, departmentWiseProduction: action.payload, error: null };
    case types.GET_DEPARTMENT_WISE_PRODUCTION_FAILURE:
      return { ...state, loading: false, error: action.payload };

    // Batch Summary
    case types.GET_BATCH_SUMMARY_REQUEST:
      return { ...state, batchSummary: { ...state.batchSummary, loading: true, error: null } };
    case types.GET_BATCH_SUMMARY_SUCCESS:
      return { ...state, batchSummary: { ...action.payload, loading: false, error: null } };
    case types.GET_BATCH_SUMMARY_FAILURE:
      return { ...state, batchSummary: { ...state.batchSummary, loading: false, error: action.payload } };

    // Pending Summary
    case types.GET_PENDING_SUMMARY_REQUEST:
      return { ...state, pendingSummary: { ...state.pendingSummary, loading: true, error: null } };
    case types.GET_PENDING_SUMMARY_SUCCESS:
      return { ...state, pendingSummary: { ...action.payload, loading: false, error: null } };
    case types.GET_PENDING_SUMMARY_FAILURE:
      return { ...state, pendingSummary: { ...state.pendingSummary, loading: false, error: action.payload } };

    // Filters
    case types.SET_DASHBOARD_FILTERS:
      return { ...state, filters: { ...state.filters, ...action.payload } };
    case types.RESET_DASHBOARD_FILTERS:
      return {
        ...state,
        filters: {
          // Reset to today
          dateFrom: dayjs().format('YYYY-MM-DD'),
          dateTo: dayjs().format('YYYY-MM-DD')
        }
      };

    default:
      return state;
  }
};

export default dashboardReducer; 